function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var GameRaceTrackTemplate = require('./game-racetrack.template');
var GameRaceTrack = /*#__PURE__*/function () {
  function GameRaceTrack(app, mod) {
    _classCallCheck(this, GameRaceTrack);
    this.app = app;
    this.mod = mod;
    this.min = 0; //Starting score
    this.win = 10; //winning score
    this.title = 'Victory Points';
    this.icon = "<i class=\"fas fa-flag-checkered\"></i>";
    //this.icon = `<i class="fa-solid fa-trophy"></i>`;

    this.players = [];
    /* Player obj
      {
        name
        score
        color
      }
     */
  }
  return _createClass(GameRaceTrack, [{
    key: "render",
    value: function render() {
      if (document.getElementById('racetrack')) {
        this.app.browser.replaceElementById(GameRaceTrackTemplate(this), 'racetrack');
      } else {
        this.app.browser.addElementToDom(GameRaceTrackTemplate(this));
      }
      this.lock();
      this.attachEvents();
    }
  }, {
    key: "advancePlayer",
    value: function advancePlayer(player) {
      var amt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      if (player < 1 || player > this.players.length) {
        return;
      }
      this.players[player - 1].score += amt;
      this.render();
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      document.querySelector('.racetrack').onclick = function (e) {
        if (document.querySelector('.racetrack').classList.contains('racetrack-lock')) {
          document.querySelector('.racetrack').classList.remove('racetrack-lock');
        } else {
          document.querySelector('.racetrack').classList.add('racetrack-lock');
        }
      };
    }
  }, {
    key: "lock",
    value: function lock() {
      try {
        document.querySelector('.racetrack').classList.add('racetrack-lock');
        setTimeout(function () {
          document.querySelector('.racetrack').classList.remove('racetrack-lock');
        }, 3000);
      } catch (err) {
        console.log(err);
      }
    }
  }]);
}();
module.exports = GameRaceTrack;